let proactive, integrity, courage, reputaion, focus, experience;

proactive = require('@/assets/icons/about/proactive.svg')
integrity = require('@/assets/icons/about/integrity.svg')
courage = require('@/assets/icons/about/courage.svg')
reputaion = require('@/assets/icons/about/reputation.svg')
focus = require('@/assets/icons/about/focus.svg')
experience = require('@/assets/icons/about/expirence.svg')

export const practicesOptions = {
    layoutMode: 'grid',
    animationType: 'quicksand',
    gapHorizontal: 0,
    gapVertical: 0,
    gridAdjustment: 'responsive',
    mediaQueries: [{
        width: 1500,
        cols: 4,
    }, {
        width: 1100,
        cols: 3,
    }, {
        width: 800,
        cols: 2
    }, {
        width: 480,
        cols: 2,
        options: {
            caption: '',
            gapHorizontal: 0,
            gapVertical: 0,
        }
    }],
    caption: 'zoom',
    displayType: 'fadeIn',
    displayTypeSpeed: 100,
};

export const principles = [
    {
        title: 'Integrity',
        content: 'We are sincere, honest and transparent with our clients.',
        icon: integrity
    },
    {
        title: 'Courage',
        content: 'We defend our clients fearlessly and passionately.',
        icon: courage
    },

    {
        title: 'Proactive',
        content: 'We are a driven team and we take-charge of every transaction from start to finish.',
        icon: proactive
    },
    {
        title: 'Reputation',
        content: 'We pride ourselves in providing top-quality legal services to our clients.',
        icon: reputaion
    },

    {
        title: 'Experience',
        content: 'We recruit the best and most experienced practitioners in the industry.',
        icon: experience
    },


    {
        title: 'Focus on You',
        content: 'We give relevant and timely business advice.',
        icon: focus
    }
];

export const articlesSliderOptions = {
    margin: 20,
    responsive: {
        0: {
            items: 1,
            nav: true,
            dots: false
        },
        600: {
            items: 2,
            nav: true,
            dots: false
        },
        1000: {
            items: 3,
            nav: true,
            dots: false
        }
    }
};

export const heroSliderOptions = {
    loop: true,
    margin: 0,
    items: 1,
    autoplay: true,
    nav: true,
    responsiveClass: true,
    responsive: {
        0: {
            items: 1,
            nav: false,
            dots: false
        },
        600: {
            items: 1,
            nav: false,
            dots: false
        },
        1120: {
            items: 1,
            dots: false,
            nav: false
        }
    }
};






// WEBPACK FOOTER //
// ./src/assets/js/exports.js